/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Fc_Cmp_Editing_LabelInputs */

const en_fc_cmp_editing_label = /** @type {(inputs: Fc_Cmp_Editing_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Core editing`)
};

/**
* | output |
* | --- |
* | "Core editing" |
*
* @param {Fc_Cmp_Editing_LabelInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const fc_cmp_editing_label = /** @type {((inputs?: Fc_Cmp_Editing_LabelInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Fc_Cmp_Editing_LabelInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_fc_cmp_editing_label(inputs)
});
export { fc_cmp_editing_label as "fc.cmp.editing.label" }